import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const PropertyView = ({ formSchemaData }: { formSchemaData?: any }) => {
  const { t } = useTranslation('app');

  const {
    watch,
    setValue,
    formState: { errors },
    clearErrors,
  } = useFormContext();
  const isError = errors.propertyView;

  const data = formSchemaData?.form.fields?.propertyView?.choices ?? {};
  const options = Object.entries(data).map(([key, value]) => ({
    key: String(key),
    label: String(value),
  }));

  const selectedClassNames = 'border-blue_light_2 bg-blue_light_2 text-blue';
  const unselectedClassNames = 'border-gray bg-white text-gray__dark_1';

  const selectedValue = watch('propertyView');

  return (
    <div className="flex flex-col gap-2x">
      <p className="text-title_4 text-black">{t('propertyView')}</p>
      <div className="flex flex-col gap-3">
        <div className="flex flex-wrap gap-1.5x">
          {options.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`
              ${isError ? 'border-red_dark' : ''}
              ${selectedValue === item.key ? selectedClassNames : unselectedClassNames}
              px-2x py-x border rounded-[12px] 
              text-body_3 transition
            `}
              onClick={() => {
                setValue('propertyView', item.key);
                clearErrors('propertyView');
              }}
            >
              {t(item.key)}
            </button>
          ))}
        </div>
        {isError && (
          <p className="text-red_dark">{t('propertyViewRequired')}</p>
        )}
      </div>
    </div>
  );
};

export default PropertyView;
